/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WebPricingRouteImport } from './routes/webPricing'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MobileRouteImport } from './routes/mobile'
import { Route as HowItWorksRouteImport } from './routes/howItWorks'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CongratulationsRouteImport } from './routes/congratulations'
import { Route as ComingSoonRouteImport } from './routes/coming-soon'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountDeletedRouteImport } from './routes/account-deleted'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EvaluationIndexRouteImport } from './routes/evaluation/index'
import { Route as EvaluationEvaluationIdRouteImport } from './routes/evaluation/$evaluationId'
import { Route as EvaluateApplicationIdRouteImport } from './routes/evaluate/$applicationId'
import { Route as DashboardSuggestedJobsRouteImport } from './routes/dashboard/suggested-jobs'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardFeedRouteImport } from './routes/dashboard/feed'
import { Route as DashboardApplicationsRouteImport } from './routes/dashboard/applications'
import { Route as DashboardAnalyticsRouteImport } from './routes/dashboard/analytics'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminSocialPostsRouteImport } from './routes/admin/social-posts'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminPushNotificationsRouteImport } from './routes/admin/push-notifications'
import { Route as AdminMessagesRouteImport } from './routes/admin/messages'
import { Route as AdminConnectorsRouteImport } from './routes/admin/connectors'
import { Route as AdminChatRouteImport } from './routes/admin/chat'
import { Route as ApplicationsLookupIdIndexRouteImport } from './routes/applications/$lookupId/index'
import { Route as ResumesResumeIdRecommendationsRouteImport } from './routes/resumes_.$resumeId.recommendations'
import { Route as ResumesResumeIdEvaluationRouteImport } from './routes/resumes_.$resumeId.evaluation'
import { Route as ApplicationsLookupIdRecommendationsRouteImport } from './routes/applications/$lookupId/recommendations'
import { Route as ApplicationsLookupIdInterviewRouteImport } from './routes/applications/$lookupId/interview'

const WebPricingRoute = WebPricingRouteImport.update({
  id: '/webPricing',
  path: '/webPricing',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileRoute = MobileRouteImport.update({
  id: '/mobile',
  path: '/mobile',
  getParentRoute: () => rootRouteImport,
} as any)
const HowItWorksRoute = HowItWorksRouteImport.update({
  id: '/howItWorks',
  path: '/howItWorks',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const DeleteAccountRoute = DeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CongratulationsRoute = CongratulationsRouteImport.update({
  id: '/congratulations',
  path: '/congratulations',
  getParentRoute: () => rootRouteImport,
} as any)
const ComingSoonRoute = ComingSoonRouteImport.update({
  id: '/coming-soon',
  path: '/coming-soon',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeletedRoute = AccountDeletedRouteImport.update({
  id: '/account-deleted',
  path: '/account-deleted',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationIndexRoute = EvaluationIndexRouteImport.update({
  id: '/evaluation/',
  path: '/evaluation/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationEvaluationIdRoute = EvaluationEvaluationIdRouteImport.update({
  id: '/evaluation/$evaluationId',
  path: '/evaluation/$evaluationId',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluateApplicationIdRoute = EvaluateApplicationIdRouteImport.update({
  id: '/evaluate/$applicationId',
  path: '/evaluate/$applicationId',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSuggestedJobsRoute = DashboardSuggestedJobsRouteImport.update({
  id: '/suggested-jobs',
  path: '/suggested-jobs',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFeedRoute = DashboardFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardApplicationsRoute = DashboardApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAnalyticsRoute = DashboardAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => DashboardRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSocialPostsRoute = AdminSocialPostsRouteImport.update({
  id: '/social-posts',
  path: '/social-posts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPushNotificationsRoute = AdminPushNotificationsRouteImport.update({
  id: '/push-notifications',
  path: '/push-notifications',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMessagesRoute = AdminMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConnectorsRoute = AdminConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChatRoute = AdminChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AdminRoute,
} as any)
const ApplicationsLookupIdIndexRoute =
  ApplicationsLookupIdIndexRouteImport.update({
    id: '/applications/$lookupId/',
    path: '/applications/$lookupId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ResumesResumeIdRecommendationsRoute =
  ResumesResumeIdRecommendationsRouteImport.update({
    id: '/resumes_/$resumeId/recommendations',
    path: '/resumes/$resumeId/recommendations',
    getParentRoute: () => rootRouteImport,
  } as any)
const ResumesResumeIdEvaluationRoute =
  ResumesResumeIdEvaluationRouteImport.update({
    id: '/resumes_/$resumeId/evaluation',
    path: '/resumes/$resumeId/evaluation',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApplicationsLookupIdRecommendationsRoute =
  ApplicationsLookupIdRecommendationsRouteImport.update({
    id: '/applications/$lookupId/recommendations',
    path: '/applications/$lookupId/recommendations',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApplicationsLookupIdInterviewRoute =
  ApplicationsLookupIdInterviewRouteImport.update({
    id: '/applications/$lookupId/interview',
    path: '/applications/$lookupId/interview',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account-deleted': typeof AccountDeletedRoute
  '/admin': typeof AdminRouteWithChildren
  '/coming-soon': typeof ComingSoonRoute
  '/congratulations': typeof CongratulationsRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/delete-account': typeof DeleteAccountRoute
  '/error': typeof ErrorRoute
  '/faq': typeof FaqRoute
  '/features': typeof FeaturesRoute
  '/howItWorks': typeof HowItWorksRoute
  '/mobile': typeof MobileRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/webPricing': typeof WebPricingRoute
  '/admin/chat': typeof AdminChatRoute
  '/admin/connectors': typeof AdminConnectorsRoute
  '/admin/messages': typeof AdminMessagesRoute
  '/admin/push-notifications': typeof AdminPushNotificationsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/social-posts': typeof AdminSocialPostsRoute
  '/admin/users': typeof AdminUsersRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/applications': typeof DashboardApplicationsRoute
  '/dashboard/feed': typeof DashboardFeedRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/suggested-jobs': typeof DashboardSuggestedJobsRoute
  '/evaluate/$applicationId': typeof EvaluateApplicationIdRoute
  '/evaluation/$evaluationId': typeof EvaluationEvaluationIdRoute
  '/evaluation': typeof EvaluationIndexRoute
  '/applications/$lookupId/interview': typeof ApplicationsLookupIdInterviewRoute
  '/applications/$lookupId/recommendations': typeof ApplicationsLookupIdRecommendationsRoute
  '/resumes/$resumeId/evaluation': typeof ResumesResumeIdEvaluationRoute
  '/resumes/$resumeId/recommendations': typeof ResumesResumeIdRecommendationsRoute
  '/applications/$lookupId': typeof ApplicationsLookupIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account-deleted': typeof AccountDeletedRoute
  '/admin': typeof AdminRouteWithChildren
  '/coming-soon': typeof ComingSoonRoute
  '/congratulations': typeof CongratulationsRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/delete-account': typeof DeleteAccountRoute
  '/error': typeof ErrorRoute
  '/faq': typeof FaqRoute
  '/features': typeof FeaturesRoute
  '/howItWorks': typeof HowItWorksRoute
  '/mobile': typeof MobileRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/webPricing': typeof WebPricingRoute
  '/admin/chat': typeof AdminChatRoute
  '/admin/connectors': typeof AdminConnectorsRoute
  '/admin/messages': typeof AdminMessagesRoute
  '/admin/push-notifications': typeof AdminPushNotificationsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/social-posts': typeof AdminSocialPostsRoute
  '/admin/users': typeof AdminUsersRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/applications': typeof DashboardApplicationsRoute
  '/dashboard/feed': typeof DashboardFeedRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/suggested-jobs': typeof DashboardSuggestedJobsRoute
  '/evaluate/$applicationId': typeof EvaluateApplicationIdRoute
  '/evaluation/$evaluationId': typeof EvaluationEvaluationIdRoute
  '/evaluation': typeof EvaluationIndexRoute
  '/applications/$lookupId/interview': typeof ApplicationsLookupIdInterviewRoute
  '/applications/$lookupId/recommendations': typeof ApplicationsLookupIdRecommendationsRoute
  '/resumes/$resumeId/evaluation': typeof ResumesResumeIdEvaluationRoute
  '/resumes/$resumeId/recommendations': typeof ResumesResumeIdRecommendationsRoute
  '/applications/$lookupId': typeof ApplicationsLookupIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account-deleted': typeof AccountDeletedRoute
  '/admin': typeof AdminRouteWithChildren
  '/coming-soon': typeof ComingSoonRoute
  '/congratulations': typeof CongratulationsRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/delete-account': typeof DeleteAccountRoute
  '/error': typeof ErrorRoute
  '/faq': typeof FaqRoute
  '/features': typeof FeaturesRoute
  '/howItWorks': typeof HowItWorksRoute
  '/mobile': typeof MobileRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/webPricing': typeof WebPricingRoute
  '/admin/chat': typeof AdminChatRoute
  '/admin/connectors': typeof AdminConnectorsRoute
  '/admin/messages': typeof AdminMessagesRoute
  '/admin/push-notifications': typeof AdminPushNotificationsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/social-posts': typeof AdminSocialPostsRoute
  '/admin/users': typeof AdminUsersRoute
  '/dashboard/analytics': typeof DashboardAnalyticsRoute
  '/dashboard/applications': typeof DashboardApplicationsRoute
  '/dashboard/feed': typeof DashboardFeedRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/suggested-jobs': typeof DashboardSuggestedJobsRoute
  '/evaluate/$applicationId': typeof EvaluateApplicationIdRoute
  '/evaluation/$evaluationId': typeof EvaluationEvaluationIdRoute
  '/evaluation/': typeof EvaluationIndexRoute
  '/applications/$lookupId/interview': typeof ApplicationsLookupIdInterviewRoute
  '/applications/$lookupId/recommendations': typeof ApplicationsLookupIdRecommendationsRoute
  '/resumes_/$resumeId/evaluation': typeof ResumesResumeIdEvaluationRoute
  '/resumes_/$resumeId/recommendations': typeof ResumesResumeIdRecommendationsRoute
  '/applications/$lookupId/': typeof ApplicationsLookupIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account-deleted'
    | '/admin'
    | '/coming-soon'
    | '/congratulations'
    | '/dashboard'
    | '/delete-account'
    | '/error'
    | '/faq'
    | '/features'
    | '/howItWorks'
    | '/mobile'
    | '/privacy'
    | '/terms'
    | '/webPricing'
    | '/admin/chat'
    | '/admin/connectors'
    | '/admin/messages'
    | '/admin/push-notifications'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/social-posts'
    | '/admin/users'
    | '/dashboard/analytics'
    | '/dashboard/applications'
    | '/dashboard/feed'
    | '/dashboard/profile'
    | '/dashboard/suggested-jobs'
    | '/evaluate/$applicationId'
    | '/evaluation/$evaluationId'
    | '/evaluation'
    | '/applications/$lookupId/interview'
    | '/applications/$lookupId/recommendations'
    | '/resumes/$resumeId/evaluation'
    | '/resumes/$resumeId/recommendations'
    | '/applications/$lookupId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/account-deleted'
    | '/admin'
    | '/coming-soon'
    | '/congratulations'
    | '/dashboard'
    | '/delete-account'
    | '/error'
    | '/faq'
    | '/features'
    | '/howItWorks'
    | '/mobile'
    | '/privacy'
    | '/terms'
    | '/webPricing'
    | '/admin/chat'
    | '/admin/connectors'
    | '/admin/messages'
    | '/admin/push-notifications'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/social-posts'
    | '/admin/users'
    | '/dashboard/analytics'
    | '/dashboard/applications'
    | '/dashboard/feed'
    | '/dashboard/profile'
    | '/dashboard/suggested-jobs'
    | '/evaluate/$applicationId'
    | '/evaluation/$evaluationId'
    | '/evaluation'
    | '/applications/$lookupId/interview'
    | '/applications/$lookupId/recommendations'
    | '/resumes/$resumeId/evaluation'
    | '/resumes/$resumeId/recommendations'
    | '/applications/$lookupId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account-deleted'
    | '/admin'
    | '/coming-soon'
    | '/congratulations'
    | '/dashboard'
    | '/delete-account'
    | '/error'
    | '/faq'
    | '/features'
    | '/howItWorks'
    | '/mobile'
    | '/privacy'
    | '/terms'
    | '/webPricing'
    | '/admin/chat'
    | '/admin/connectors'
    | '/admin/messages'
    | '/admin/push-notifications'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/social-posts'
    | '/admin/users'
    | '/dashboard/analytics'
    | '/dashboard/applications'
    | '/dashboard/feed'
    | '/dashboard/profile'
    | '/dashboard/suggested-jobs'
    | '/evaluate/$applicationId'
    | '/evaluation/$evaluationId'
    | '/evaluation/'
    | '/applications/$lookupId/interview'
    | '/applications/$lookupId/recommendations'
    | '/resumes_/$resumeId/evaluation'
    | '/resumes_/$resumeId/recommendations'
    | '/applications/$lookupId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountDeletedRoute: typeof AccountDeletedRoute
  AdminRoute: typeof AdminRouteWithChildren
  ComingSoonRoute: typeof ComingSoonRoute
  CongratulationsRoute: typeof CongratulationsRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  DeleteAccountRoute: typeof DeleteAccountRoute
  ErrorRoute: typeof ErrorRoute
  FaqRoute: typeof FaqRoute
  FeaturesRoute: typeof FeaturesRoute
  HowItWorksRoute: typeof HowItWorksRoute
  MobileRoute: typeof MobileRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  WebPricingRoute: typeof WebPricingRoute
  EvaluateApplicationIdRoute: typeof EvaluateApplicationIdRoute
  EvaluationEvaluationIdRoute: typeof EvaluationEvaluationIdRoute
  EvaluationIndexRoute: typeof EvaluationIndexRoute
  ApplicationsLookupIdInterviewRoute: typeof ApplicationsLookupIdInterviewRoute
  ApplicationsLookupIdRecommendationsRoute: typeof ApplicationsLookupIdRecommendationsRoute
  ResumesResumeIdEvaluationRoute: typeof ResumesResumeIdEvaluationRoute
  ResumesResumeIdRecommendationsRoute: typeof ResumesResumeIdRecommendationsRoute
  ApplicationsLookupIdIndexRoute: typeof ApplicationsLookupIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/webPricing': {
      id: '/webPricing'
      path: '/webPricing'
      fullPath: '/webPricing'
      preLoaderRoute: typeof WebPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile': {
      id: '/mobile'
      path: '/mobile'
      fullPath: '/mobile'
      preLoaderRoute: typeof MobileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/howItWorks': {
      id: '/howItWorks'
      path: '/howItWorks'
      fullPath: '/howItWorks'
      preLoaderRoute: typeof HowItWorksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete-account': {
      id: '/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof DeleteAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/congratulations': {
      id: '/congratulations'
      path: '/congratulations'
      fullPath: '/congratulations'
      preLoaderRoute: typeof CongratulationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon': {
      id: '/coming-soon'
      path: '/coming-soon'
      fullPath: '/coming-soon'
      preLoaderRoute: typeof ComingSoonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-deleted': {
      id: '/account-deleted'
      path: '/account-deleted'
      fullPath: '/account-deleted'
      preLoaderRoute: typeof AccountDeletedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluation/': {
      id: '/evaluation/'
      path: '/evaluation'
      fullPath: '/evaluation'
      preLoaderRoute: typeof EvaluationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluation/$evaluationId': {
      id: '/evaluation/$evaluationId'
      path: '/evaluation/$evaluationId'
      fullPath: '/evaluation/$evaluationId'
      preLoaderRoute: typeof EvaluationEvaluationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluate/$applicationId': {
      id: '/evaluate/$applicationId'
      path: '/evaluate/$applicationId'
      fullPath: '/evaluate/$applicationId'
      preLoaderRoute: typeof EvaluateApplicationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/suggested-jobs': {
      id: '/dashboard/suggested-jobs'
      path: '/suggested-jobs'
      fullPath: '/dashboard/suggested-jobs'
      preLoaderRoute: typeof DashboardSuggestedJobsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/feed': {
      id: '/dashboard/feed'
      path: '/feed'
      fullPath: '/dashboard/feed'
      preLoaderRoute: typeof DashboardFeedRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/applications': {
      id: '/dashboard/applications'
      path: '/applications'
      fullPath: '/dashboard/applications'
      preLoaderRoute: typeof DashboardApplicationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics': {
      id: '/dashboard/analytics'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof DashboardAnalyticsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/social-posts': {
      id: '/admin/social-posts'
      path: '/social-posts'
      fullPath: '/admin/social-posts'
      preLoaderRoute: typeof AdminSocialPostsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/push-notifications': {
      id: '/admin/push-notifications'
      path: '/push-notifications'
      fullPath: '/admin/push-notifications'
      preLoaderRoute: typeof AdminPushNotificationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/messages': {
      id: '/admin/messages'
      path: '/messages'
      fullPath: '/admin/messages'
      preLoaderRoute: typeof AdminMessagesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/connectors': {
      id: '/admin/connectors'
      path: '/connectors'
      fullPath: '/admin/connectors'
      preLoaderRoute: typeof AdminConnectorsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/chat': {
      id: '/admin/chat'
      path: '/chat'
      fullPath: '/admin/chat'
      preLoaderRoute: typeof AdminChatRouteImport
      parentRoute: typeof AdminRoute
    }
    '/applications/$lookupId/': {
      id: '/applications/$lookupId/'
      path: '/applications/$lookupId'
      fullPath: '/applications/$lookupId'
      preLoaderRoute: typeof ApplicationsLookupIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resumes_/$resumeId/recommendations': {
      id: '/resumes_/$resumeId/recommendations'
      path: '/resumes/$resumeId/recommendations'
      fullPath: '/resumes/$resumeId/recommendations'
      preLoaderRoute: typeof ResumesResumeIdRecommendationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resumes_/$resumeId/evaluation': {
      id: '/resumes_/$resumeId/evaluation'
      path: '/resumes/$resumeId/evaluation'
      fullPath: '/resumes/$resumeId/evaluation'
      preLoaderRoute: typeof ResumesResumeIdEvaluationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/$lookupId/recommendations': {
      id: '/applications/$lookupId/recommendations'
      path: '/applications/$lookupId/recommendations'
      fullPath: '/applications/$lookupId/recommendations'
      preLoaderRoute: typeof ApplicationsLookupIdRecommendationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/$lookupId/interview': {
      id: '/applications/$lookupId/interview'
      path: '/applications/$lookupId/interview'
      fullPath: '/applications/$lookupId/interview'
      preLoaderRoute: typeof ApplicationsLookupIdInterviewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminChatRoute: typeof AdminChatRoute
  AdminConnectorsRoute: typeof AdminConnectorsRoute
  AdminMessagesRoute: typeof AdminMessagesRoute
  AdminPushNotificationsRoute: typeof AdminPushNotificationsRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSocialPostsRoute: typeof AdminSocialPostsRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminChatRoute: AdminChatRoute,
  AdminConnectorsRoute: AdminConnectorsRoute,
  AdminMessagesRoute: AdminMessagesRoute,
  AdminPushNotificationsRoute: AdminPushNotificationsRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSocialPostsRoute: AdminSocialPostsRoute,
  AdminUsersRoute: AdminUsersRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DashboardRouteChildren {
  DashboardAnalyticsRoute: typeof DashboardAnalyticsRoute
  DashboardApplicationsRoute: typeof DashboardApplicationsRoute
  DashboardFeedRoute: typeof DashboardFeedRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardSuggestedJobsRoute: typeof DashboardSuggestedJobsRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAnalyticsRoute: DashboardAnalyticsRoute,
  DashboardApplicationsRoute: DashboardApplicationsRoute,
  DashboardFeedRoute: DashboardFeedRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardSuggestedJobsRoute: DashboardSuggestedJobsRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountDeletedRoute: AccountDeletedRoute,
  AdminRoute: AdminRouteWithChildren,
  ComingSoonRoute: ComingSoonRoute,
  CongratulationsRoute: CongratulationsRoute,
  DashboardRoute: DashboardRouteWithChildren,
  DeleteAccountRoute: DeleteAccountRoute,
  ErrorRoute: ErrorRoute,
  FaqRoute: FaqRoute,
  FeaturesRoute: FeaturesRoute,
  HowItWorksRoute: HowItWorksRoute,
  MobileRoute: MobileRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  WebPricingRoute: WebPricingRoute,
  EvaluateApplicationIdRoute: EvaluateApplicationIdRoute,
  EvaluationEvaluationIdRoute: EvaluationEvaluationIdRoute,
  EvaluationIndexRoute: EvaluationIndexRoute,
  ApplicationsLookupIdInterviewRoute: ApplicationsLookupIdInterviewRoute,
  ApplicationsLookupIdRecommendationsRoute:
    ApplicationsLookupIdRecommendationsRoute,
  ResumesResumeIdEvaluationRoute: ResumesResumeIdEvaluationRoute,
  ResumesResumeIdRecommendationsRoute: ResumesResumeIdRecommendationsRoute,
  ApplicationsLookupIdIndexRoute: ApplicationsLookupIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
